import SectionHeading from '@/components/base/SectionHeading';
import { SITE_NAME } from '@/mocks/site';

export default function PositionSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="position-heading">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <SectionHeading
            id="position-heading"
            eyebrow="Position"
            title="网站定位与品牌介绍"
            desc="不是赛事主办方的招商页，而是一个把时间与进度说明白的信息站。"
          />
        </div>

        <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className="ri-compass-3-line text-lg"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">我们是谁</h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {SITE_NAME}赛程站是一个独立运营的赛事信息整理站点。我们把官方公布的赛程、活动安排与进度节点重新梳理成清晰的时间表，方便选手和围观的朋友随时查询。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-6">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-focus-3-line text-lg"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">我们服务谁</h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              主要面向已报名或准备参与的选手，以及关注赛事进展的内容创作者和媒体。无论你是想看截稿时间，还是想追决赛进度，都能在这里找到对应答案。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-6">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
              <i className="ri-lightbulb-flash-line text-lg"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">发展理念</h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              赛程信息最大的成本是「反复确认」。我们希望把这件事一次做透，用固定的时间口径和清晰的阶段划分，减少每个人重复询问的时间。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-6">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200 text-foreground-700">
              <i className="ri-line-chart-line text-lg"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">内容范围</h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              只发布与赛事时间、流程、规则相关的信息，包括阶段起止、关键节点、活动安排、奖项设置与常见疑问，不涉及与赛事无关的内容。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}